
<section class="container-fluid sts-section">

    <app-sts-section-header key="sts-select-communication-header"  [errors]="errors">
      Select Preferred Communication Channel
      <app-sts-section-header-side>
        <div class="text-right"><a
          routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
        </div>
      </app-sts-section-header-side>
    </app-sts-section-header>

    <app-sts-section-body *ngIf="hasCommunicationChannels" key="sts-select-communication-body-section">
      We have on file both your phone and your email. Please select your preffered communication channel from the list below.
    </app-sts-section-body>


    <form #form="ngForm"
          (ngSubmit)="onSubmitCode()"
          [formGroup]="frmComm"
          class="sts-form" autocomplete="off">

      <div class="row sts-form-row">
        <div class="col-24">
          <div class="sts-object">
            <div>
              <select *ngIf="hasCommunicationChannels" formControlName="selComm" [ngClass]="{'has-errors' : isInvalidChoice() }"
                class="sts-dropdown-comm sts-textbox">
                <option ngClass="sts-textbox select-items" selected="selected" value="0">
                  <span app-sts-cms-txt key="sts-select-drop-down-text">
                    Select
                  </span>
                </option>
                <option ngClass="sts-textbox select-items" *ngFor="let channel of communicationChannels" [ngValue]="channel.text">
                  {{channel.text}}
                </option>
              </select>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-24">
          <div class="sts-object">
            <button app-sts-cms-txt key="sts-cancel-button"
                    class="sts-btn other-sts-btn"
                    type="button"
                    (click)="goHome()">
              Cancel
            </button>

            <app-sts-button *ngIf="hasCommunicationChannels" [submit]="submitter" key="sts-next-button">
              Next
            </app-sts-button>
          </div>
        </div>
      </div>
    </form>
  </section>


